import * as d3 from 'd3'

export default {
  methods: {

    draw_exception() {
      let except = null
      
      if(this.currentArea.status == 'OVERALL') {
        except = this.rawData.filter(f => 
          f.EXCEPT == 'Y' && 
          f[`${this.currentStage.col}`] !== '' && 
          f[`${this.currentStage.ref}`] !== undefined
        )
      } else {
        except = this.rawData.filter(f =>
          f.AREA ==  this.currentArea.status &&
          f.EXCEPT == 'Y' && 
          f[`${this.currentStage.col}`] !== '' && 
          f[`${this.currentStage.ref}`] !== undefined
        )
      }

      if (except.length == 0) return

      except.forEach((d,i) => {
 
        if(d[`${this.currentStage.pro}`] == 0 || d[`${this.currentStage.pro}`] == '') d.bColor = '#fff'
        else d.bColor = this.currentStage.color

        if(d[`${this.currentStage.pro}`] > 0 && d[`${this.currentStage.pro}`] < 100) d.opacity = .2
        else d.opacity  = 1

      })


      // Sorting Date
      let self_ = this
      function executeSort(a, b) { 
        if(a[`${self_.currentStage.ref}`] == b[`${self_.currentStage.ref}`]){ return 0} return a[`${self_.currentStage.ref}`] > b[`${self_.currentStage.ref}`] ? 1 : -1; 
      } 
      except.sort(executeSort)


      let self = this
      this.canvasExcept = this.svg
      .append('g')
      .attr('id', 'EXCEPTION')
      .attr('transform', `translate(50.5, 1000.5)`)
      .attr('font-family', 'roboto')

      this.ExceptFront = this.svg
      .append('g')
      .attr('id', 'EXCEPTION_2ndLayer')
      .attr('transform', `translate(50.5, 1000.5)`)
      .attr('font-family', 'roboto')       

      this.canvasExcept
      .append('text')
      .attr('transform', `translate(0, 0)`)
      .attr('font-size', 11)
      .attr('fill', '#F35E90')
      .text('Blocks not included on the timeline')

      let hovorScale = 1.4
      let drawX = 12
      
      let width_ = this.currentStage.width
      let s_ = this.currentStage

      except.forEach((d, i) => {

        let x_ = drawX
        let y_ = 0
        
        let Boxes = this.canvasExcept
        .append('g')
        .attr('id', `BOX_${d[this.currentStage.col]}`)
        .attr('transform', `translate(${x_}, 10)`)
        .style('cursor', 'pointer')
        .on('mouseover', function() {
          let factor = (hovorScale - 1) / 2
          let scale_x = width_ * factor
          let scale_y = self.skyline.height * factor

            self.ExceptFront.selectAll('*').remove()
            self.canvasFront.selectAll('*').remove()

            let hoverBox = self.ExceptFront
            .append('g')
            .attr('transform', `translate(${x_}, 10) scale(${1})`)
            .style('cursor', 'pointer')
            .on('mouseout', () => {
              self.ExceptFront.selectAll('*').remove()
              d3.select(this).transition().duration(150)
              .attr('transform', `translate(${x_}, 10) scale(1)`)
      
              d3.select('#DETAIL').transition().delay(500).duration(300)
              .attr('opacity', self.detail.onOff == 'ON' ? 1 : 0)
            })
            .on('click', () => {
              self.link_Skyline(d)
            })

            d3.select(this)
            .selectAll('*')
            .each(function () {
              hoverBox.node().appendChild(this.cloneNode(true))
            })          
          
          hoverBox.transition().duration(150)
          .attr('transform', `translate(${x_-scale_x},${y_-scale_y+10}) scale(${hovorScale})`)

          d3.select('#DETAIL').transition().duration(200)
          .attr('opacity', 1)

          self.mouseOver_Detail(d) // ---> Detailed Information
        })

        Boxes
        .append('rect') // Background
        .attr('x', 0).attr('y',0)
        .attr('rx', 1)
        .attr('ry', 1)
        .attr('width', width_)
        .attr('height', this.skyline.height)
        .attr('fill', '#fff')
        .attr('stroke', '#757575')
        .attr('stroke-width', .5)

        Boxes
        .append('rect') // Fill Color
        .attr('x', 0).attr('y',0)
        .attr('rx', 1)
        .attr('ry', 1)
        .attr('width', width_ * (d[this.currentStage.pro]/100))
        .attr('height', this.skyline.height)
        .attr('fill', d.bColor)
        .attr('fill-opacity', 1)
      
        Boxes
        .append('text')
        .attr('x', width_/2)
        .attr('y', this.skyline.height/2 + 1 + 9*0.26)
        .attr('font-family', this.skyline.font)
        .attr('font-size', 8.5)
        .attr('fill', '#000')
        .attr('text-anchor', 'middle')
        .style('pointer-events', 'none')
        .text(d[this.currentStage.col])

        let Sch = this.canvasExcept
        .append('text')
        .attr('x', drawX + width_ + 8)
        .attr('y', 18 + 9*0.26)
        .attr('font-family', this.skyline.font)
        .attr('font-size', 9)
        .attr('fill', '#000')
        .attr('text-anchor', 'start')
        .style('pointer-events', 'none')
        .text(d[this.currentStage.ref])

        drawX = drawX + 100
      })


    },
    

  }
}
